export default __webpack_public_path__ + "static/media/i136vp.86d91751.webp";